export default function ({ store, app }) {
    const jivoChatId = store.state.global.globalSettings?.sitesettingsstatistic?.jivo_chat;

    if (jivoChatId) {
        app.head.script.push({
            hid: 'jivochat',
            innerHTML: `(function(){ var widget_id = '${jivoChatId}'; var d = document; var w = window; function l(){ var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://code.jivosite.com/script/widget/' + widget_id; var ss = document.getElementsByTagName('script')[0]; ss.parentNode.insertBefore(s, ss);} if(d.readyState == 'complete'){l();} else{if(w.attachEvent){w.attachEvent('onload', l);} else{w.addEventListener('load', l, false);}}})();`,
            type: 'text/javascript',
            charset: 'utf-8'
        });

        if (!app.head.__dangerouslyDisableSanitizersByTagID) {
            app.head.__dangerouslyDisableSanitizersByTagID = {};
        }
        app.head.__dangerouslyDisableSanitizersByTagID['jivochat'] = ['innerHTML'];
    }
}
